import React, { useState } from "react";
import { DispatchPlanningActions, ReoptimizationReviewActions } from "./DispatchRibbonSection.jsx";

export default function DispatchFullscreenActions({ interactions, model }) {
  const [snapshotActionsRoot, setSnapshotActionsRoot] = useState(null);
  const [primaryActionsRoot, setPrimaryActionsRoot] = useState(null);
  const [portalActionsRoot, setPortalActionsRoot] = useState(null);
  const [sourceChangesActionsRoot, setSourceChangesActionsRoot] = useState(null);
  const headerSlots = { snapshotActionsRoot, primaryActionsRoot, portalActionsRoot, sourceChangesActionsRoot };

  return (
    <div className="flex w-full min-w-0 flex-wrap items-center justify-end gap-2" data-fleet-fullscreen-actions="true">
      <div ref={setSnapshotActionsRoot} className="dispatch-header-slot" />
      <div ref={setSourceChangesActionsRoot} className="dispatch-header-slot" />
      <div ref={setPrimaryActionsRoot} className="dispatch-header-slot" />
      <div ref={setPortalActionsRoot} className="dispatch-header-slot" />
      <ReoptimizationReviewActions interactions={interactions} model={model} headerSlots={headerSlots} />
      <DispatchPlanningActions interactions={interactions} model={model} headerSlots={headerSlots} fillSourceChangesIndicator={false} />
    </div>
  );
}
